module.exports = __webpack_public_path__ + "static/media/credit-card.46bea6c5.svg";